import {
  allowNavigation,
  getConfirmationMessage,
} from "../hooks/useInterceptorPrompt";
import { isBuildStale } from "./staleBuild";

// Asks before leaving a form guarded by useInterceptorPrompt, false when the person stays; navigate() itself never asks
export function confirmNavigation(): boolean {
  const confirmationMessage = getConfirmationMessage();
  if (confirmationMessage && !confirm(confirmationMessage)) return false;

  // navigate() leaves the page while the build is stale, do not ask twice
  if (confirmationMessage && isBuildStale()) allowNavigation();
  return true;
}
